import { render, staticRenderFns } from "./MatriculasPendentesContrato.vue?vue&type=template&id=2e833a36"
import script from "./MatriculasPendentesContrato.vue?vue&type=script&lang=js"
export * from "./MatriculasPendentesContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports